module.exports = __webpack_public_path__ + "static/Allphins-205c00446ce7ccb6ae4b533ebe148220.jpg";